module.exports = __webpack_public_path__ + "img/line3.197fb3f2.jpg";